import React from 'react';
import AuthorizedAction from '../../AuthorizedAction.js';

const StakeholdersUploadStatus = ({ initiative, onDownloadErrorsCsv }) => {
  return initiative.stakeholderStructureErrors ? (
    <div className="component-xl component-xl component-bg-white component-border-bottom text-center">
      <h3 className="text-danger">
        There was an issue with the Stakeholders CSV.
      </h3>
      <br />
      <br />

      {initiative.project[
        `manage${initiative.type.charAt(0).toUpperCase() + initiative.type.slice(1)}Initiatives`
      ] ? (
        <AuthorizedAction
          action="update"
          subject={`${initiative.type}Initiative`}
        >
          <p className="no-margin">
            Please download the CSV error report
            <button
              type="button"
              className="btn-link"
              onClick={onDownloadErrorsCsv}
            >
              here
            </button>
          </p>
        </AuthorizedAction>
      ) : null}
    </div>
  ) : null;
};

export default StakeholdersUploadStatus;
